import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { render } from "react-dom";
import { Outlet, Route } from "react-router-dom";
import SettingsField from "../SettingsField";
import { AuthContext } from "../../../contexts/AuthContext";
import PasswordReset from "./PasswordReset";
import AvatarUpload from "./AvatarUpload";
import { UserCircleIcon } from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const tabs = [
  {
    name: "Account info",
    href: "#",
    icon: UserCircleIcon,
    current: true,
  },
];

export default function User({}) {
  // Load user profile settings into the state
  // Get these from supabase directly supabase.auth.getUser()
  // Do a deep compare to see if anything is different

  const { session, supabase } = useContext(AuthContext);
  const [confirmationText, setConfirmationText] = useState(false);
  const [newSettings, setNewSettings] = useState({
    username: null,
    email: null,
  });
  useEffect(() => {}, [session]);

  const saveUpdates = async () => {
    // Create an update object to efficiently add data
    let update = {};

    // If the user updates their email, add it to the update object
    if (
      newSettings.email &&
      newSettings.email.toLowerCase() != session.user.email.toLowerCase()
    ) {
      update.email = newSettings.email;
    }

    // If the user updates their username, add it to the update object
    if (newSettings.username) {
      if (newSettings.username.trim().length < 1) {
        alert("Username must be at least one character.");
        return;
      }
      update.data = { username: newSettings.username };
    }

    // If the update object is not empty, update the user
    if (Object.keys(update).length > 0) {
      const { data, error } = await supabase.auth.updateUser(update);
      alert("Updated user settings");
      if (error) {
        alert("Something went wrong trying to update your profile");
        return;
      }
    }

    // Construct the confirmation text we want to show
    let newConfirmationText = "";
    if (newSettings.username) {
      newConfirmationText += "Updated username. ";
    }
    if (newSettings.email) {
      newConfirmationText +=
        "Confirm your new email by clicking on the link we sent. ";
    }
    setConfirmationText(newConfirmationText);

    setNewSettings({ username: null, email: null });
  };

  // Update metadata
  async function updateProfile(event, avatarUrl) {
    event.preventDefault();
    const update = {};
    update.data = { avatar: avatarUrl };
    const { data, error } = await supabase.auth.updateUser(update);
  }

  return (
    <div className="relative" style={{ minHeight: "80vh" }}>
      <h1 className="text-lg font-bold text-gray-800">
        Manage personal settings
      </h1>

      <div className="mb-8">
        <div className="sm:hidden">
          <label htmlFor="tabs" className="sr-only">
            Select a tab
          </label>
          {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
          <select
            id="tabs"
            name="tabs"
            className="block w-full rounded-md border-gray-300 focus:border-gray-500 focus:ring-gray-500"
            defaultValue={tabs.find((tab) => tab.current).name}
          >
            {tabs.map((tab) => (
              <option key={tab.name}>{tab.name}</option>
            ))}
          </select>
        </div>
        <div className="hidden sm:block">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
              {tabs.map((tab) => (
                <a
                  key={tab.name}
                  href={tab.href}
                  className={classNames(
                    tab.current
                      ? "border-gray-800 text-gray-600"
                      : "border-transparent text-gray-800 hover:border-gray-300 hover:text-gray-700",
                    "group inline-flex items-center border-b-2 py-4 px-1 text-xs font-medium"
                  )}
                  aria-current={tab.current ? "page" : undefined}
                >
                  <tab.icon
                    className={classNames(
                      tab.current
                        ? "text-gray-800"
                        : "text-gray-400 group-hover:text-gray-500",
                      "-ml-0.5 mr-2 h-3 w-3"
                    )}
                    aria-hidden="true"
                  />
                  <span>{tab.name}</span>
                </a>
              ))}
            </nav>
          </div>
        </div>
      </div>

      <div className="space-y-4 w-2/3">
        <AvatarUpload
          url={session?.user?.user_metadata?.avatar}
          onUpload={(event, url) => {
            console.log({ event, url });
            updateProfile(event, url);
          }}
          size={80}
        />
        <SettingsField
          label={"Your name"}
          onChange={(e) =>
            setNewSettings({ ...newSettings, username: e.target.value })
          }
          value={
            newSettings?.username || session?.user?.user_metadata?.username
          }
          type="text"
        />
        <SettingsField
          label={"Email address"}
          onChange={(e) =>
            setNewSettings({ ...newSettings, email: e.target.value })
          }
          value={newSettings?.email || session?.user?.email}
          type="text"
        />
        <PasswordReset />
      </div>
      {(newSettings?.username || newSettings?.email) && (
        <div className="mt-8 space-x-2">
          <button
            onClick={() => setNewSettings({ username: null, email: null })}
            className="border shadow-sm bg-white text-gray-700 rounded-md px-3 py-2 text-sm font-medium"
          >
            Discard updates
          </button>
          <button
            onClick={() => saveUpdates()}
            className="bg-gray-800 text-white rounded-md text-sm px-3 py-2 font-medium"
          >
            Save updates
          </button>
        </div>
      )}

      {confirmationText && (
        <div className="mt-4 text-sm text-gray-700">
          <p>{confirmationText}</p>
        </div>
      )}
    </div>
  );
}
